import React from 'react';
import { PortfolioProduct } from '../api/API';
import ProductCard from './ProductCard';
import '../assets/css/ProductCard.css';
import { useTranslate } from '../services/translation';

interface ProductListProps {
  products: PortfolioProduct[];
  limit?: number;
  showViewMore?: boolean;
  onViewMore?: () => void;
}

const ProductList: React.FC<ProductListProps> = ({
  products,
  limit,
  showViewMore = false,
  onViewMore,
}) => {
  const { translate } = useTranslate();
  const displayedProducts = limit ? products.slice(0, limit) : products;

  if (products.length === 0) {
    return (
      <div className="product-list-empty">
        <p className="light">{translate("common.no_project_available")}</p>
      </div>
    );
  }

  return (
    <div className="product-list-container">
      <div className="product-grid">
        {displayedProducts.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>

      {showViewMore && products.length > displayedProducts.length && onViewMore && (
        <div className="product-view-more">
          <button className="btn-view-more" onClick={onViewMore}>
            {translate("common.view_more_projects")}
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductList;
